/* Marobali — détecte si le header est réellement opaque (fond blanc) pour garder icônes et menu lisibles */
(function () {
	function update() {
		var h = document.querySelector('theme-header');
		if (!h) { return; }
		var c = getComputedStyle(h).backgroundColor || '';
		var m = c.match(/rgba?\(([^)]+)\)/);
		var a = 1;
		if (m) {
			var p = m[1].split(',');
			a = p.length > 3 ? parseFloat(p[3]) : 1;
		}
		var solid = a >= 0.25;
		if (solid !== h.hasAttribute('data-mb-solid')) {
			if (solid) { h.setAttribute('data-mb-solid', ''); } else { h.removeAttribute('data-mb-solid'); }
		}
	}

	update();
	['scroll', 'resize', 'load', 'pageshow', 'mouseover', 'mouseout', 'touchstart', 'touchend', 'transitionend'].forEach(function (ev) {
		window.addEventListener(ev, update, { passive: true, capture: true });
	});
	setInterval(update, 250);
})();
